import styled, { css, DefaultTheme } from 'styled-components';
import { CheckIconStyling, StarIconComposedStyling } from './types';

function iconColor(
  color: string,
  noFill: boolean = false,
  noStroke: boolean = false
) {
  const fillColor = noFill ? 'none' : color;
  const strokeColor = noStroke ? 'none' : color;
  return css`
    g,
    path,
    circle {
      fill: ${fillColor};
      stroke: ${strokeColor};
    }
  `;
}

function getCheckColorFromStyle(theme: DefaultTheme, style?: CheckIconStyling) {
  switch (style) {
    case 'neutral-light':
      return theme.colors.base0;
    case 'primary':
    default:
      return theme.colors.base700;
  }
}

function getStarColorFromStyle(
  theme: DefaultTheme,
  style?: StarIconComposedStyling
) {
  switch (style) {
    case 'active':
      return theme.colors.yellove700;
    case 'inactive':
    case 'active-alt':
      return theme.colors.base300;
    case 'inactive-alt':
      return theme.colors.base500;
    case 'half-alt':
    case 'half':
    default:
      return theme.colors.base700;
  }
}

function checkIconStyles(theme: DefaultTheme, iconStyle?: CheckIconStyling) {
  return iconColor(getCheckColorFromStyle(theme, iconStyle), true, false);
}

function starIconStyles(
  theme: DefaultTheme,
  iconStyle?: StarIconComposedStyling
) {
  return iconColor(getStarColorFromStyle(theme, iconStyle), false, true);
}

interface StyledCheckIconProps {
  $styling: CheckIconStyling;
}

export const StyledCheckIcon = styled.svg<StyledCheckIconProps>`
  position: relative;
  ${p => checkIconStyles(p.theme, p.$styling)};
`;

interface StyledStarIconProps {
  $styling: StarIconComposedStyling;
}

export const StyledStarIcon = styled.svg<StyledStarIconProps>`
  ${p => starIconStyles(p.theme, p.$styling)};
  ${p =>
    (p.$styling === 'half-alt' || p.$styling === 'half') &&
    css`
      path {
        fill: ${p.$styling === 'half'
          ? 'url(#halfGradient)'
          : 'url(#halfGradientAlt)'};
      }
    `}
`;

export const StopFirstHalf = styled.stop`
  stop-color: ${p => p.theme.colors.yellove700};
`;
export const StopFirstHalfAlt = styled.stop`
  stop-color: ${p => p.theme.colors.base500};
`;
export const StopSecondHalf = styled.stop`
  stop-color: ${p => p.theme.colors.base300};
`;
